<script setup>
  import Loader from "@/components/Loader.vue"
  import WorkingAsBar from "@/components/WorkingAsBar.vue"   // Oct 22: warehouse "Working as" bar
  import useUserStore from '@/stores/user.js'
  import usedbStore from '@/stores/db.js'
  import {
    useCurrentUser,
    getCurrentUser
  } from 'vuefire';
  import * as Sentry from "@sentry/vue";
  const userStore = useUserStore()
  const dbStore = usedbStore()
  const user = useCurrentUser()


  if (!dbStore.stateData.initialized && userStore.stateData.isLoggedIn) {
    dbStore.initialize(userStore.stateData.uid)
  }

  // Oct 4: the portal remembers "logged in" in the browser separately from the
  // real Firebase login. If the real login is gone (browser data cleared,
  // password changed, account disabled) the pages can't load the client's data
  // anymore. Catch that once at startup and send them to log in again.
  if (userStore.stateData.isLoggedIn) {
    getCurrentUser()
      .then((u) => {
        if (!u) {
          try { localStorage.setItem('pw_session_expired', '1') } catch (e) {}
          window.location = '/logout'
        }
      })
      .catch((e) => console.warn('[auth] could not check login:', e))
  }

  const refreshUser = async() => {
    // Real login already gone: the startup check above handles that.
    if (userStore.stateData.isLoggedIn && user.value) {
      try {
        user.value.getIdTokenResult(true)
          .then(function (idToken) {
            console.log("Successfully refreshed user.")
          }).catch(function (error) {
            console.error(error)
          });
      } catch (error) {
        if (error.message == "user.value is null") {
          window.location = '/logout'
        } else {
          console.error(error)
        }
      }
    }
  }
  setInterval(() => {
    refreshUser()
  }, 1000*60*30)
  setTimeout(() => {
    refreshUser()
  }, 1000*5)
  
  if (userStore.stateData.isLoggedIn) {
    Sentry.setUser({ email: userStore.stateData.email, username: userStore.stateData.uid });
    OpenReplay.setUserID(userStore.stateData.uid)
  }
</script>

<template>
  <!-- <n-config-provider> -->
  <n-loading-bar-provider>
    <n-message-provider>
      <n-dialog-provider>
        <!-- <RouterView></RouterView> -->
        <!-- <RouterView v-if="userStore.stateData.isLoggedIn && dbStore.stateData.completed"></RouterView> -->
        <!-- <RouterView v-if="userStore.stateData.ready"></RouterView> -->
        <!-- <RouterView v-if="dbStore.stateData.completed"></RouterView> -->
        <WorkingAsBar />
        <RouterView
          v-if="$route.meta.auth_no_preference || (($route.meta.requires_auth || false) && dbStore.stateData.completed) || (!($route.meta.requires_auth || false) && !dbStore.stateData.completed)">
        </RouterView>
        <Loader v-else></Loader>
        <!-- {{ $route.meta.requires_auth && dbStore.stateData.completed }} -->
        <!-- <p>{{$route}}</p> -->
      </n-dialog-provider>
    </n-message-provider>
  </n-loading-bar-provider>
  <!-- </n-config-provider> -->
</template>

<style scoped>
</style>
